import BookingRouteScreen from "./BookingRouteScreen";

export default BookingRouteScreen;
